/* eslint-disable object-curly-newline */
import listPlatforms from './list_platforms';
import listAdministratif, { listAnnexesEstate } from '../containers/AssetDetails/components/list_administratif';

export default function getContactName(contacts, id) {
  for (let i = 0; i < contacts.length; i += 1) {
    if (contacts[i]._id === id) return `${contacts[i].given_name} ${contacts[i].family_name && contacts[i].family_name.toUpperCase()}`;
  }
  return '';
}

export function getContactNameForAvatar(contacts, id) {
  for (let i = 0; i < contacts.length; i += 1) {
    if (contacts[i]._id === id) return `${contacts[i].given_name && contacts[i].given_name.charAt(0)} ${contacts[i].family_name && contacts[i].family_name.charAt(0)}`;
  }
  return '';
}

export const getContactEmail = (contacts, id) => {
  for (let i = 0; i < contacts.length; i += 1) {
    if (contacts[i]._id === id) return contacts[i].email;
  }
  return '';
};

export const verifyEmail = email => (/^[A-Za-zÀ-ÖØ-öø-ÿ0-9._-]+@(?:[A-Za-z0-9À-ÖØ-öø-ÿ-]+\.)+[A-Za-z]+$/.test(email));

export const verifyPassword = password => (/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$+/%^&amp;*-])(?=.{8,})/.test(password));

export const checkAlreadyExistEmail = (contacts, email, contact_id = '') => {
  if (contacts.filter(e => e.email === email && e._id !== contact_id).length > 0) {
    return true;
  }
  return false;
};

export const areObjectEquals = (object1, object2) => {
  if (!object1 || !object2) return false;

  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  let isEqual = true;
  Object.keys(object1).forEach((key) => {
    if (object1[key] !== object2[key]) {
      isEqual = false;
    }
  });

  return isEqual;
};

export const isAtLeastOneAccess = (permissions) => {
  let atLeastOneAccess = false;
  Object.values(permissions).forEach((e) => {
    if (e !== 'never') atLeastOneAccess = true;
  });
  return atLeastOneAccess;
};

export const isAtLeastOneAccessEmergency = (permissions) => {
  let atLeastOneAccess = false;
  Object.values(permissions).forEach((e) => {
    if (e) atLeastOneAccess = true;
  });
  return atLeastOneAccess;
};

export const isAtLeastOneFiconumAccess = (permissions) => {
  let atLeastOneAccess = false;
  if (!permissions) return atLeastOneAccess;
  Object.values(permissions).forEach((e) => {
    if (e) atLeastOneAccess = true;
  });
  return atLeastOneAccess;
};

export const isEnoughSpace = (files, storage_left) => {
  let fullSize = 0;

  files.forEach((file) => {
    fullSize += parseInt(file.size, 10);
  });

  if (fullSize > storage_left) {
    return false;
  }
  return true;
};

export const getListEmails = (user, assets) => {
  let listEmails = [];
  if (user.list_emails && user.list_emails.length > 0) listEmails = [...user.list_emails];
  // console.log('listemails: ', listEmails);
  listEmails.forEach((e, i, newArr) => {
    if (newArr[i]) {
      newArr[i].isAlreadySent = true;
    }
  });
  assets.forEach((e) => {
    if (e.login_email && verifyEmail(e.login_email)) {
      if (!listEmails.some(item => item.email === e.login_email)) {
        listEmails.push({ email: e.login_email, status: 'inactive' });
        // console.log(e.login_email);
      }
    }
    if (e.login_other && verifyEmail(e.login_other)) {
      if (!listEmails.some(item => item.email === e.login_other)) {
        listEmails.push({ email: e.login_other, status: 'inactive' });
        // console.log(e.login_other);
      }
    }
    if (e.credential && verifyEmail(e.credential)) {
      if (!listEmails.some(item => item.email === e.credential)) {
        listEmails.push({ email: e.credential, status: 'inactive' });
        // console.log(e.credential);
      }
    }
  });
  // console.log(listEmails);
  return listEmails;
};

export const customStyles = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: 'rgba(235, 166, 76, 0.2)',
    primary75: 'rgba(235, 166, 76, 0.6)',
    primary50: 'rgba(235, 166, 76, 0.4)',
    primary: '#eba64c',
  },
});

export const customStylesTotal = {
  control: (provided, state) => ({
    ...provided,
    background: state.isDisabled ? '#f0f6fc' : '#fff',
    borderColor: '#e2e4e7',
    minHeight: '40px',
    height: '40px',
    cursor: 'pointer',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: provided => ({
    ...provided,
    height: '40px',
    padding: '0 6px',
  }),
  input: provided => ({
    ...provided,
    margin: '0px',
    padding: '0px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorsContainer: provided => ({
    ...provided,
    height: '40px',
  }),
  colors: provided => ({
    ...provided,
    primary25: 'rgba(235, 166, 76, 0.2)',
    primary75: 'rgba(235, 166, 76, 0.6)',
    primary50: 'rgba(235, 166, 76, 0.4)',
    primary: '#eba64c',
  }),
};

export const getSubLabel = (type, form_type, data) => {
  const { subcategory } = data;
  let category = type === 'assets' ? data.category : data.img; // img used for planner
  if (subcategory === 'life_insurance') category = 'life_insurance';
  else if (subcategory === 'sci') category = 'sci';
  else if (subcategory === 'unlisted') category = 'unlisted';
  else if (subcategory === 'family_company') category = 'family_company';
  else if (subcategory === 'capitalization_contract') category = 'capitalization_contract';
  else if (subcategory === 'per') category = 'Plan d\'épargne retraite';
  else if (subcategory === 'fcpi') category = 'fcpi';
  else if (subcategory === 'movable') category = 'movable';
  else if (subcategory === 'industrial') category = 'industrial';
  else if (subcategory === 'copyright') category = 'copyright';
  else if (subcategory === 'employee_savings_plan') category = 'employee_savings_plan';
  else if (subcategory === 'madelin') category = 'madelin';
  else if (subcategory === 'collective_pension') category = 'collective_pension';
  else if (subcategory === 'other_contract') category = 'other_contract';
  const list = {
    documents: {
      insurance: 'Ex: contrat et avenants',
      life_insurance: 'Ex: contrat et avenants',
      bank: 'Ex: Synthèse, relevé global des comptes',
      estate: 'Ex: acte notarié, titre de propriété...',
      insurance_goods: 'Ex: copie du contrat, facture, etc',
      insurance_person: 'Ex: copie du contrat, facture, etc',
      donation: 'Ex: copie de l\'acte, etc',
      mobile: 'Ex: copie du contrat, facture, etc',
      energy: 'Ex: copie du contrat, facture, etc',
      water: 'Ex: copie du contrat, facture, etc',
      internet_box: 'Ex: copie du contrat, facture, etc',
      house_insurance: 'Ex: copie du contrat, facture, etc',
      car_insurance: 'Ex: copie du contrat, facture, etc',
      mutuelle: 'Ex: copie du contrat, facture, etc',
      loan: 'Ex: copie du contrat',
      boss: 'Ex: copie du contrat de travail, fiche de paye, etc',
      owner: 'Ex: copie du bail, quittance de loyer, etc',
      tenant: 'Ex: copie du bail, quittance de loyer, etc',
      maid: 'Ex: copie du contrat de travail, fiche de paie, etc',
      shop: 'Ex: status, Kbis, bilan',
      car: 'Ex: Copie de la carte grise',
      sci: 'Ex: Status, Kbis, bilan, éventuel pacte d\'associés',
      unlisted: 'Ex: extrait registre des actionnaires, certificat, éventuel pacte d\'associés',
      family_company: 'Ex: status, Kbis, bilan, éventuel pacte d\'associés',
      company: 'Ex: status, Kbis, bilan, pacte d\'associés',
      capitalization_contract: 'Ex: contrat et avenants',
      fcpi: 'Ex: bulletin de souscription',
      movable: 'Ex: certificat d\'authenticité, facture',
      art: 'Ex: certificat d\'authenticité, facture, inventaire',
      intellectual: 'Ex: éventuelle preuve de dépôt',
      copyright: 'Ex: éventuelle preuve de dépôt',
      industrial: 'Ex: brevet, preuve de dépôt, contrat de concession',
      employee_savings_plan: 'Ex: relevé annuel de situation',
      madelin: 'Ex: contrat et avenants',
      collective_pension: 'Ex: contrat et avenants',
      other_contract: 'Ex: contrat et avenants',
    },
    notes: {
      life_insurance: 'Ex: date de souscription et de versement des primes',
      donation: 'Ex: A qui était-elle destinée / de qui provenait-elle ?',
      movable: 'Ex: club de collectionneurs, cabinet d\'expertise',
      art: 'Ex: comissaire priseur, gallerie',
      bank: 'Ex: types de comptes détenus (comptes épargne, comptes titres, comptes courants)',
      company: 'Ex: contacts utiles pour la valorisation (expert comptable, avocat, expert en valorisation)',
      shop: 'Ex: contacts utiles pour la valorisation (expert comptable, avocat, expert en valorisation)',
      employee_savings_plan: 'Ex: contact RH de la société',
      collective_pension: 'Ex: contact RH de la société',
      madelin: 'Ex: contact RH de la société',
      intellectual: 'Ex: contacts utiles',
      copyright: 'Ex: contacts utiles (éditeur, gallerie, expert)',
      industrial: 'Ex: contacts utiles (expert)',
      car: 'Ex: date de première mise en circulation',
      pet: 'Ex: numéro de tatouage ou puce, assurance pour votre animal, etc',
      // sci: 'Ex: éventuel pacte d\'associés',
    },
    contacts: {
      sci: 'Ex: expert comptable',
      unlisted: 'Ex: expert comptable',
      family_company: 'Ex: expert comptable',
      shop: 'Ex: expert comptable, avocat, expert en valorisation',
      company: 'Ex: expert comptable, avocat, expert en valorisation',
      copyright: 'Ex: éditeur, gallerie, expert',
      industrial: 'Ex: expert',
      madelin: 'Ex: contact RH de la société',
      collective_pension: 'Ex: contact RH de la société',
      employee_savings_plan: 'Ex: contact RH de la société',
    },
  };
  let result = '';
  if (list[form_type] && list[form_type][category]) {
    result = list[form_type][category];
  }
  return result;
};

export const getNotesPlaceholder = (category) => {
  if (category === 'album') return 'Quel message, quelle histoire souhaitez-vous rattacher à cet album ?';
  if (category === 'item_memory') return 'Votre objet possède certainement une histoire : racontez-là...';
  return 'Décrivez votre bien, précisez vos instructions, détaillez qu\'en faire...';
};

export function getListAssetsFromCompany(assets, assetId) {
  return assets.filter(x => x.linked_company_id === assetId);
}

export function getListAssets(mainCategory, search, filter, order, assets) {
  let listAssets = [];
  if (search !== '') {
    // résultat de recherche
    if (mainCategory === 'numeric') {
      listAssets = assets.filter(x => x.category === 'numeric' && x.title.toLowerCase().includes(search) && !x.linked_company_id);
    } else if (mainCategory === 'data') {
      listAssets = assets.filter(x => ['data', 'cloud'].includes(x.category) && x.title.toLowerCase().includes(search) && !x.linked_company_id);
    } else if (mainCategory === 'cloud') {
      listAssets = assets.filter(x => x.category === 'cloud' && x.title.toLowerCase().includes(search) && !x.linked_company_id);
    } else if (mainCategory === 'classic') {
      listAssets = assets.filter(x => ['insurance', 'estate', 'art', 'item', 'other_investment', 'bank'].includes(x.category) && x.title.toLowerCase().includes(search) && !x.linked_company_id);
    } else if (mainCategory === 'professional') {
      listAssets = assets.filter(x => ['shop', 'contract', 'company', 'intellectual'].includes(x.category) && x.title.toLowerCase().includes(search) && !x.linked_company_id);
    } else if (mainCategory === 'memories') {
      listAssets = assets.filter(x => ['album', 'text', 'item_memory'].includes(x.category) && x.title.toLowerCase().includes(search) && !x.linked_company_id);
    }
  } else if (filter !== 'all') {
    // résultat d'un filtre
    if (filter === 'complete') {
      listAssets = assets.filter(x => x.contacts.length > 0);
    } else {
      listAssets = assets.filter(x => x.contacts.length === 0);
    }
  } else if (order === 'all') {
    // résultat par défaut : ensemble de la liste
    if (mainCategory === 'numeric') {
      listAssets = assets.filter(x => x.category === 'numeric' && !x.linked_company_id);
    } else if (mainCategory === 'data') {
      listAssets = assets.filter(x => ['data', 'cloud'].includes(x.category) && !x.linked_company_id);
    } else if (mainCategory === 'cloud') {
      listAssets = assets.filter(x => x.category === 'cloud' && !x.linked_company_id);
    } else if (mainCategory === 'classic') {
      listAssets = assets.filter(x => ['insurance', 'bank', 'estate', 'art', 'item', 'other_investment'].includes(x.category) && !x.linked_company_id);
    } else if (mainCategory === 'professional') {
      listAssets = assets.filter(x => ['shop', 'contract', 'company', 'intellectual'].includes(x.category) && !x.linked_company_id);
    } else if (mainCategory === 'memories') {
      listAssets = assets.filter(x => ['album', 'text', 'item_memory'].includes(x.category) && !x.linked_company_id);
    }
  } else {
    // résultat si un bouton / toggle de catégorie de bien a été choisi
    listAssets = assets.filter(x => x.category === order && !x.linked_company_id);
  }
  return listAssets;
}

export function getContactRole(type, gender) {
  // gender: mr ; mrs
  const male = {
    husband_wife: {
      name: 'Époux',
    },
    child: {
      name: 'Fils',
    },
    concubine: {
      name: 'Concubin',
    },
    companion: {
      name: 'Compagnon',
    },
    parent: {
       name: 'Père',
    },
    sibling: {
      name: 'Frère',
    },
    nephew: {
      name: 'Neveu',
    },
    cousin: {
      name: 'Cousin germain',
    },
    grandparent: {
      name: 'Grand-père',
    },
    greatchild: {
      name: 'Petit-fils',
    },
    uncle: {
      name: 'Oncle',
    },
    other: {
      name: 'Aucun lien de parenté',
    },
  };
  const female = {
    husband_wife: {
      name: 'Épouse',
    },
    child: {
      name: 'Fille',
    },
    concubine: {
      name: 'Concubine',
    },
    companion: {
      name: 'Compagne',
    },
    parent: {
       name: 'Mère',
    },
    sibling: {
      name: 'Soeur',
    },
    nephew: {
      name: 'Nièce',
    },
    cousin: {
      name: 'Cousine germaine',
    },
    grandparent: {
      name: 'Grand-mère',
    },
    greatchild: {
      name: 'Petite-fille',
    },
    uncle: {
      name: 'Tante',
    },
    other: {
      name: 'Aucun lien de parenté',
    },
  };
  const values = {
    mr: male,
    mrs: female,
  };
  const valuesNoGender = {
    parent: {
      name: 'Père ou mère',
    },
    sibling: {
      name: 'Frère ou soeur',
    },
    nephew: {
      name: 'Neveu ou nièce',
    },
    cousin: {
      name: 'Cousin(e) germain(e)',
    },
    child: {
      name: 'Fils ou fille',
    },
    grandparent: {
      name: 'Grand-père ou grand-mère',
    },
    greatchild: {
      name: 'Petit-fils ou petite-fille',
    },
    uncle: {
      name: 'Oncle ou tante',
    },
    other: {
      name: 'Aucun lien de parenté',
    },
  };
  if (['mr', 'mrs'].includes(gender)) {
    if (type in values[gender]) {
      return values[gender][type].name;
    }
  }
  if (type in valuesNoGender) {
    return valuesNoGender[type].name;
  }
  return 'Non spécifié';
}

export function getGenderName(gender) {
  const list = {
    male: { name: 'Mr' },
    female: { name: 'Mme' },
  };
  if (gender in list) {
    return list[gender].name;
  }
  return 'Non spécifié';
}

export function getListSubCategories(category) {
  const list = {
    numeric: [
      { value: 'online_bank', label: 'Banque en ligne' },
      { value: 'money_game', label: 'Jeu d\'argent' },
      { value: 'jackpot', label: 'Cagnotte en ligne' },
      { value: 'domain_name', label: 'Nom de domaine' },
      { value: 'wallet', label: 'Crypto Wallet' },
      { value: 'crypto_currency', label: 'Cryptomonnaie' },
      { value: 'other', label: 'Autre' },
    ],
    data: [
      { value: 'social_network', label: 'Réseau social' },
      { value: 'account_personal', label: 'Compte personnel' },
      { value: 'email', label: 'Messagerie' },
      { value: 'website', label: 'Site internet, Blog ou Application' },
      { value: 'other', label: 'Autre' },
    ],
    cloud: [
      { value: 'cloud', label: 'Cloud personnel' },
      { value: 'safe_deposit', label: 'Coffre-fort numérique' },
    ],
    insurance: [
      { value: 'life_insurance', label: 'Assurance vie' },
      { value: 'provident_insurance', label: 'Assurance prévoyance' },
      { value: 'funeral_insurance', label: 'Assurance obsèques' },
    ],
    art: [
      { value: 'movable', label: 'Bien meuble (objet, mobilier, véhicule...)' },
      { value: 'art', label: 'Œuvre d\'art ou collection' },
      // { value: 'collection', label: 'Collection' },
    ],
    intellectual: [
      { value: 'copyright', label: 'Droits d\'auteur' },
      { value: 'industrial', label: 'Propriété industrielle' },
      // { value: 'collection', label: 'Collection' },
    ],
    estate: [
      { value: 'main_house', label: 'Résidence principale' },
      { value: 'second_house', label: 'Résidence secondaire' },
      // { value: 'house', label: 'Maison' },
      // { value: 'flat', label: 'Appartement' },
      // { value: 'building', label: 'Immeuble' },
      { value: 'land', label: 'Terrain' },
      { value: 'parking', label: 'Parking / garage' },
      { value: 'building_rent', label: 'Immeuble locatif' },
      { value: 'sci', label: 'Parts de SCI, GF, GFA...' },
      // { value: 'barn', label: 'Remise / grange' },
      // { value: 'life', label: 'Viager' },
      { value: 'other', label: 'Autres biens immeubles' },
    ],
    // securities: [
    //   { value: 'stocks', label: 'Actions' },
    //   { value: 'bonds', label: 'Obligations' },
    //   { value: 'ucits', label: 'OPCVM' },
    //   { value: 'invest_certificate', label: 'Certificat d\'investissement' },
    //   { value: 'subscription_warrants', label: 'Bon de souscription' },
    //   { value: 'warrants', label: 'Warrants' },
    //   { value: 'options', label: 'Options' },
    //   { value: 'stock_options', label: 'Stock options' },
    //   { value: 'cfd', label: 'Contrats de différence' },
    //   { value: 'futures', label: 'Futures' },
    // ],
    contract: [
      { value: 'employee_savings_plan', label: 'Plan d\'épargne salariale' },
      { value: 'collective_pension', label: 'Prévoyance collective' },
      { value: 'madelin', label: 'Contrat Madelin' },
      { value: 'other_contract', label: 'Contrats divers' },
    ],
    other_investment: [
      { value: 'capitalization_contract', label: 'Contrat de capitalisation' },
      { value: 'per', label: 'Plan d\'épargne retraite' },
      { value: 'unlisted', label: 'Titres de sociétés non côtés' },
      { value: 'fcpi', label: 'Parts de FCPI, SCPI...' },
      { value: 'family_company', label: 'Parts de société familiale' },
      { value: 'other', label: 'Placements atypiques divers' },
      // { value: 'gfa', label: 'Parts de GFA, GAF, GFV et GFR' },
      // { value: 'tontine', label: 'Tontines' },
      // { value: 'bonds', label: 'Obligations' },
      // { value: 'ucits', label: 'OPCVM' },
      // { value: 'invest_certificate', label: 'Certificat d\'investissement' },
      // { value: 'subscription_warrants', label: 'Bon de souscription' },
      // { value: 'warrants', label: 'Warrants' },
      // { value: 'options', label: 'Options' },
      // { value: 'stock_options', label: 'Stock options' },
      // { value: 'futures', label: 'Futures' },
      // { value: 'fcpi', label: 'FCPI' },
      // { value: 'fcpr', label: 'FCPR' },
      // { value: 'fip', label: 'FIP' },
      // { value: 'fpci', label: 'FPCI' },
      // { value: 'forest_gff', label: 'Forêt / GFF' },
      // { value: 'forest_gfi', label: 'Forêt / GFI' },
      // { value: 'pme_invest', label: 'Investissement direct PME' },
      // { value: 'sofica', label: 'Sofica' },
      // { value: 'farming_lands', label: 'Terres agricoles / GFA' },
      // { value: 'vines', label: 'Vignes / GFV' },
      // { value: 'wine', label: 'Vin' },
    ],
  };
  return list[category];
}

export function getListInsurancesType(subcategory) {
  const list = {
    insurance_person: [
      { value: 'insurance_mutuelle', label: 'Mutuelle' },
      { value: 'insurance_accident', label: 'Garantie accident de la vie' },
      { value: 'insurance_dependant', label: 'Assurance dépendance' },
      { value: 'insurance_handicap', label: 'Assurance handicap' },
      { value: 'insurance_borrow', label: 'Assurance emprunteur' },
      { value: 'insurance_legal', label: 'Assurance juridique' },
    ],
    insurance_goods: [
      { value: 'insurance_house', label: 'Assurance habitation' },
      { value: 'insurance_car', label: 'Assurance auto' },
      { value: 'insurance_equipment', label: 'Assurance équipement' },
      { value: 'insurance_rent', label: 'Assurance location' },
    ],
  };
  return list[subcategory];
}

export function getPreSelectedSubCategory(category, value) {
  const list = getListSubCategories(category);
  if (list && value) {
    const picked = list.find(e => e.value === value) || {};
    return picked;
  }
  return {};
}

export function getPreSelectedByType(subcategory, type) {
  const list = getListInsurancesType(subcategory);
  if (list) {
    const picked = list.find(e => e.value === type) || {};
    return picked;
  }
  return {};
}

export function getLabelFromType(subcategory, type) {
  if (subcategory === 'donation') return type;
  const list = getListInsurancesType(subcategory);
  if (list) {
    const picked = list.find(e => e.value === type) || {};
    return picked.label;
  }
  return '';
}

export function getLabelFromSubcategory(subcategory, category) {
  const list = category === 'company' ? listAdministratif : listAnnexesEstate;
  if (list) {
    let isFound = {};
    list.forEach((e) => {
      const test = e.listing.find(item => item.img === subcategory);
      if (test) isFound = test;
    });
    if (isFound) return isFound.title;
    return '';
  }
  return '';
}

export function getSubcategoriesByCat(category) {
  const list = listPlatforms.filter(e => e.category === category);
  const listCat = [];
  list.forEach((item) => {
    if (listCat.filter(e => (e.subcategory_parent === item.subcategory_parent)).length === 0) {
      listCat.push(item);
    }
  });
  return listCat;
}

export function getPlatformsByCatAndSubcatParent(category, subcategory_parent) {
  const list = listPlatforms.filter(e => e.category === category && e.subcategory_parent === subcategory_parent);
  return list;
}

export function searchPlatformByTxt(txt, mainCategory) {
  let list;
  if (['numeric', 'cloud'].includes(mainCategory)) {
    // 'data',
    list = listPlatforms.filter(item => item.category === mainCategory && (item.title.toLowerCase().includes(txt.toLowerCase()) || item.img.toLowerCase().includes(txt.toLowerCase())));
  } else if (mainCategory === 'classic') {
    list = listPlatforms.filter(item => item.category === 'insurance' && (item.title.toLowerCase().includes(txt.toLowerCase()) || item.img.toLowerCase().includes(txt.toLowerCase())));
  } else if (mainCategory === 'data') {
    list = listPlatforms.filter(item => ['cloud', 'data'].includes(item.category) && (item.title.toLowerCase().includes(txt.toLowerCase()) || item.img.toLowerCase().includes(txt.toLowerCase())));
  }
  return list;
}

export function renderTxtSearch(mainCategory) {
  if (mainCategory === 'data') return 'une plateforme';
  if (mainCategory === 'cloud') return 'un cloud';
  if (mainCategory === 'memories') return 'un souvenir';
  return 'un bien';
}

export function getPlatformInfoByValue(value) {
  const result = listPlatforms.find(item => item.img === value);
  return result;
}

export function getPlatformList(type) {
  const list = {
    online_account: [
      {
        type: 'title', value: 'Winamax', label: 'Winamax',
      },
      {
        type: 'title', value: 'Pokerstar', label: 'Pokerstar',
      },
      {
        type: 'title', value: 'Betclic', label: 'BetClic',
      },
      {
        type: 'title', value: 'Paypal', label: 'Paypal',
      },
      {
        type: 'title', value: 'Twitch', label: 'Twitch',
      },
    ],
    social_network: [
      {
        type: 'title', value: 'Facebook', label: 'Facebook',
      },
      {
        type: 'title', value: 'Linkedin', label: 'Linkedin',
      },
      {
        type: 'title', value: 'Twitter', label: 'Twitter',
      },
    ],
  };
  if (type) {
    return (list[type]);
  }
  return list;
}

export function getArrayMainCategoriesByCategory(category) {
  const list = {
    numeric: ['numeric', 'data', 'cloud'],
    classic: ['insurance', 'bank', 'other_investment', 'art', 'estate', 'intellectual'],
    professional: ['shop', 'contract', 'company', 'industrial'],
  };
  return list[category];
}

export function getMainCategoryFromCategory(category) {
  const list = {
    numeric: ['numeric'],
    data: ['data', 'cloud'],
    classic: ['insurance', 'bank', 'other_investment', 'art', 'estate', 'intellectual'],
    professional: ['shop', 'contract', 'company', 'industrial'],
    planner: ['finance', 'housing', 'subscription'],
  };
  if (list.numeric.includes(category)) return 'numeric';
  if (list.data.includes(category)) return 'data';
  if (list.classic.includes(category)) return 'classic';
  if (list.professional.includes(category)) return 'professional';
  if (list.planner.includes(category)) return 'planner';
  return 'memories';
}

export function getMenuFromCategory(category) {
  const list = {
    numeric: ['numeric'],
    data: ['data', 'cloud'],
    classic: ['insurance', 'bank', 'other_investment', 'art', 'estate', 'intellectual'],
    professional: ['shop', 'contract', 'company', 'industrial'],
    planner: ['finance', 'housing', 'subscription'],
  };
  if (list.numeric.includes(category)) return 'Biens numériques';
  if (list.data.includes(category)) return 'Vie numérique';
  if (list.classic.includes(category)) return 'Patrimoine';
  if (list.professional.includes(category)) return 'Informations Pro';
  if (list.planner.includes(category)) return 'Administratif';
  return '';
}

export function getListCategories() {
  const list = {
    numeric: [
      { value: 'coinbase', title: 'Coinbase', img: 'coinbase', subcategory: 'wallet' },
      { value: 'kraken', title: 'Kraken', img: 'kraken', subcategory: 'wallet' },
      { value: 'binance', title: 'Binance', img: 'binance', subcategory: 'wallet' },
      { value: 'crypto', title: 'Cryptomonnaies', img: 'crypto', subcategory: 'crypto_currency' },
      { value: 'winamax', title: 'Winamax', img: 'winamax', subcategory: 'money_game' },
      { value: 'pokerstars', title: 'Pokerstars', img: 'pokerstars', subcategory: 'money_game' },
      { value: 'betclic', title: 'BetClic', img: 'betclic', subcategory: 'money_game' },
      { value: 'paypal', title: 'Paypal', img: 'paypal', subcategory: 'online_bank' },
      { value: 'n26', title: 'N26', img: 'n26', subcategory: 'online_bank' },
      { value: 'revolut', title: 'Revolut', img: 'revolut', subcategory: 'online_bank' },
      { value: 'pumpkin', title: 'Pumpkin', img: 'pumpkin', subcategory: 'online_bank' },
    ],
    data: [
      { value: 'facebook', title: 'Facebook', img: 'facebook', subcategory: 'social_network' },
      { value: 'linkedin', title: 'Linkedin', img: 'linkedin', subcategory: 'social_network' },
      { value: 'twitter', title: 'Twitter', img: 'twitter', subcategory: 'social_network' },
      { value: 'twitch', title: 'Twitch', img: 'twitch', subcategory: 'account_personal' },
      { value: 'gmail', title: 'Gmail', img: 'gmail', subcategory: 'email' },
      { value: 'outlook', title: 'Outlook', img: 'outlook', subcategory: 'email' },
    ],
    cloud: [
      { value: 'dropbox', img: 'dropbox', title: 'Dropbox', subcategory: 'cloud' },
      { value: 'google_drive', img: 'google_drive', title: 'Google Drive', subcategory: 'cloud' },
      { value: 'icloud', img: 'icloud', title: 'iCloud', subcategory: 'cloud' },
      { value: 'legitbee', img: 'legitbee', title: 'Legitbee', subcategory: 'safe_deposit' },
    ],
    insurance: [
      { value: 'natixis', img: 'natixis', title: 'Natixis', subcategory: 'insurance' },
      { value: 'banque_populaire', img: 'banque_populaire', title: 'Banque populaire', subcategory: 'insurance' },
      { value: 'caisse_epargne', img: 'caisse_epargne', title: 'Caisse d\'épargne', subcategory: 'insurance' },
      { value: 'axa', img: 'axa', title: 'Axa', subcategory: 'insurance' },
      { value: 'boursorama', img: 'boursorama', title: 'Boursorama', subcategory: 'insurance' },
    ],
  };
  return list;
}

export function getPlatformByCategory(category) {
  return listPlatforms.filter(e => e.category === category);
  // if (category && list[category]) {
  //   return (list[category]);
  // }
  // return [{
  //   value: 'None',
  //   title: 'Non disponible',
  // }];
}

export function getListBanks() {
  const list = getPlatformByCategory('bank').sort((a, b) => {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  });
  const final_list = [];
  list.forEach((e) => {
    final_list.push({ value: e.img, label: e.title });
  });
  return final_list;
}

export function getListCompanyRoles() {
  return [
    { type: 'role', value: 'leader', label: 'Dirigeant.e' },
    { type: 'role', value: 'cofunder', label: 'Co-fondateur.trice' },
    { type: 'role', value: 'associate', label: 'Associé.e' },
  ];
}

export function getPreSelectedRole(role) {
  const list = getListCompanyRoles().find(e => e.value === role);
  if (list) return list;
  return {};
}

export function getListContractTypes() {
  return [
    { type: 'contract_type', value: 'pee', label: 'PEE' },
    { type: 'contract_type', value: 'percol', label: 'PERCOL' },
    { type: 'contract_type', value: 'perin', label: 'PERIN' },
    { type: 'contract_type', value: 'perob', label: 'PEROB' },
    { type: 'contract_type', value: 'cet', label: 'CET' },
  ];
}

export function getPreSelectedContractType(contract_type) {
  const list = getListContractTypes().find(e => e.value === contract_type);
  if (list) return list;
  return {};
}

export function getListNatureParts() {
  return [
    { type: 'nature_parts', value: 'stocks', label: 'Actions' },
    { type: 'nature_parts', value: 'shares', label: 'Parts sociales' },
    { type: 'nature_parts', value: 'bonds', label: 'Obligations' },
    { type: 'nature_parts', value: 'subscription_warrants', label: 'Bons de souscription' },
  ];
}

export function getNaturePartByValue(value) {
  const list = getListNatureParts().find(e => e.value === value);
  if (list) return list.label;
  return 'Non défini';
}

export function getContractTypeByValue(value) {
  const list = getListContractTypes().find(e => e.value === value);
  if (list) return list.label;
  return 'Non défini';
}

export function getPreSelectedNatureParts(nature_parts) {
  const list = getListNatureParts().find(e => e.value === nature_parts);
  if (list) return list;
  return {};
}

export function getListInsurances() {
  const list = getPlatformByCategory('insurance').sort((a, b) => {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  });
  const final_list = [];
  list.forEach((e) => {
    final_list.push({ value: e.img, label: e.title });
  });
  return final_list;
}

export function getPreSelectedByTitle(title) {
  const platform = listPlatforms.find(e => e.title === title);
  let val = {};
  if (platform) {
    val = { value: platform.img, label: platform.title };
  }
  return val;
}

export function checkTitleIsInList(title, category) {
  let result = false;
  if (category) result = listPlatforms.find(e => e.title === title && e.category === category);
  else result = listPlatforms.find(e => e.title === title);
  if (result) return true;
  return false;
}

export function getImgByTitle(title) {
  let val = 'default';
  const result = listPlatforms.find(e => e.title === title);
  if (result) {
    val = result.img;
  }
  return val;
}

export function getListCrypto() {
  return [
    { label: 'Bitcoin', value: 'bitcoin', isMain: true },
    { label: 'Ethereum', value: 'ethereum', isMain: true },
    { label: 'Litecoin', value: 'litecoin', isMain: true },
    { label: 'Tether', value: 'tether', isMain: false },
    { label: 'Ripple', value: 'ripple', isMain: false },
    { label: 'Cardano', value: 'cardano', isMain: false },
  ];
}

export function getImgCryptoByTitle(name) {
  let val = 'default';
  if (name) {
    const list = listPlatforms.filter(e => e.subcategory === 'crypto_currency');
    list.forEach((item) => {
      if (item.title === name) val = item.img;
      return 'ok';
    });
  }
  return val;
}

export function checkIfIsPlanner(subcategory) {
  const listSubCat = ['mobile', 'energy', 'internet_box', 'tv', 'magazine', 'gym', 'house_insurance', 'car_insurance', 'mutuelle', 'loan', 'boss', 'owner', 'tenant', 'maid', 'dog', 'software'];
  return listSubCat.includes(subcategory);
}

export function getImgLocalPath(data) {
  const {
    category, title, subcategory, isPlanner,
  } = data;
  if (isPlanner || checkIfIsPlanner(subcategory)) return `${subcategory}.svg`;
  if (title) {
    if (subcategory === 'crypto_currency') {
      return `crypto/${getImgCryptoByTitle(title)}.png`;
    }
    const imgFound = getImgByTitle(title);
    if (['estate', 'bank', 'art', 'other_investment', 'art', 'item', 'intellectual', 'shop', 'company', 'contract'].includes(category) || imgFound === 'default') {
      return `${category}.png`;
    }
    return `logo/${imgFound}.png`;
  }
  return `${category}.png`;
}

export function getSecureKeyOptions() {
  return [
    { type: 'secureKeyChoice', value: 'legitbee', label: '100% Legitbee' },
    { type: 'secureKeyChoice', value: 'legitbee_other', label: 'Division Legitbee + Proches et/ou Notaire' },
    { type: 'secureKeyChoice', value: 'other', label: 'Proches et/ou Notaire' },
  ];
}

export function formatSecureKeyChoice(choice) {
  const list = getSecureKeyOptions();
  let val = { type: 'secureKeyChoice', value: undefined, label: 'Non défini' };
  list.forEach((item) => {
    if (item.value === choice) val = item;
    return 'ok';
  });
  return val;
}

export function getSecureKeyNameByValue(option) {
  const list = getSecureKeyOptions();
  let val = 'Non défini';
  list.forEach((item) => {
    if (item.value === option) val = item.label;
    return 'ok';
  });
  return val;
}

export function getDecisionsList() {
  return [
    { type: 'decisions', value: 'transmit', label: 'À transmettre' },
    { type: 'decisions', value: 'delete', label: 'À supprimer' },
  ];
}

export function getDecisionItem(value) {
  const list = getDecisionsList();
  let val = { type: 'decisions', value: 'none', label: 'Non défini' };
  list.forEach((item) => {
    if (item.value === value) val = item;
    return 'ok';
  });
  return val;
}

export function formatDecisions(decisions) {
  // console.log(decisions);
  const endList = [];
  decisions.map(item => endList.push(getDecisionItem(item)));
  return endList;
}

export function formatPermalinkContacts(contacts, allContacts) {
  // console.log(decisions);
  const endList = [];
  contacts.forEach((item) => {
    if (item && item.given_name) {
      endList.push({ value: item._id, label: `${item.given_name} ${item.family_name}` });
    } else {
      endList.push({ value: item, label: getContactName(allContacts, item) });
    }
  });
  return endList;
}

export function getLinkOptions() {
  return [
    { type: 'link', value: 'trusted', label: 'Personne de confiance' },
    { type: 'link', value: 'wealth_manager', label: 'Gestionnaire de patrimoine' },
    { type: 'link', value: 'associate', label: 'Associé' },
    { type: 'link', value: 'accountant', label: 'Comptable' },
    { type: 'link', value: 'notary', label: 'Notaire' },
    { type: 'link', value: 'banker', label: 'Banquier' },
    { type: 'link', value: 'tenant', label: 'Locataire' },
    { type: 'link', value: 'boss', label: 'Employeur' },
    { type: 'link', value: 'other', label: 'Autre' },
  ];
}

export function getFilesSorting(arr, order, orderBy) {
  const result1 = [];
  const result2 = [];
  for (let i = 0; i < arr.length; i += 1) {
    if (arr[i].type === 'folder') {
      result1.push(arr[i]);
    } else {
      result2.push(arr[i]);
    }
  }
  if (order === 'asc') {
    result2.sort((a, b) => {
      const varA = orderBy === 'name' ? a[orderBy].toLowerCase() : a[orderBy];
      const varB = orderBy === 'name' ? b[orderBy].toLowerCase() : b[orderBy];
      if (varA < varB) {
        return -1;
      }
      if (varA > varB) {
        return 1;
      }
      return 0;
    });
  } else {
    result2.sort((a, b) => {
      const varA = orderBy === 'name' ? a[orderBy].toLowerCase() : a[orderBy];
      const varB = orderBy === 'name' ? b[orderBy].toLowerCase() : b[orderBy];
      if (varA > varB) {
        return -1;
      }
      if (varA < varB) {
        return 1;
      }
      return 0;
    });
  }
  return result1.sort((a, b) => {
    if (order === 'asc') {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      }
      return 0;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return -1;
    }
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
      return 1;
    }
    return 0;
  }).concat(result2);
  // if (order === 'desc') {
  //   return (a, b) => {
  //     if ((a.type !== 'folder' && b.type === 'folder') || a[orderBy] > b[orderBy]) {
  //       return 1;
  //     }
  //     if ((a.type === 'folder' && b.type !== 'folder') || a[orderBy] < b[orderBy]) {
  //       return -1;
  //     }
  //     // return a[orderBy] - b[orderBy];
  //     // if (a[orderBy] < b[orderBy]) {
  //     //   return -1;
  //     // }
  //     // if (a[orderBy] > b[orderBy]) {
  //     //   return 1;
  //     // }
  //     return 0;
  //   };
  // }
  // return (a, b) => {
  //   if (a[orderBy] > b[orderBy]) {
  //     return -1;
  //   }
  //   if (a[orderBy] < b[orderBy]) {
  //     return 1;
  //   }
  //   return 0;
  // };
}

export function renderIconFileType(type) {
  let img = 'file';
  if (type === 'image/png' || type === 'image/jpeg') {
    img = 'photo';
  } else if (type === 'application/pdf') {
    img = 'pdf';
  } else if (type === 'text/plain') {
    img = 'txt';
  } else if (type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    img = 'excel';
  }
  return img;
}

export function getLinkLabel(link) {
  const list = getLinkOptions();
  let labelResult = 'Autre';
  list.forEach((item) => {
    const { value, label } = item;
    if (value === link) labelResult = label;
  });
  return labelResult;
}

export function getContactCategoriesList() {
  return [
    { type: 'categories', value: 'numeric', label: 'Biens numériques' },
    { type: 'categories', value: 'data', label: 'Comptes personnels' },
    { type: 'categories', value: 'cloud', label: 'Clouds' },
    { type: 'categories', value: 'insurance', label: 'Assurances vie' },
  ];
}

export function getContactCategoryItem(value) {
  const list = getContactCategoriesList();
  let val = { type: 'categories', value: 'none', label: 'Non défini' };
  list.forEach((item) => {
    if (item.value === value) val = item;
    return 'ok';
  });
  return val;
}

export function formatContactCategories(categories) {
  const endList = [];
  categories.map(item => endList.push(getDecisionItem(item)));
  return endList;
}

export function getCategoryName(cat) {
  const list = {
    numeric: 'Bien numérique',
    data: 'Compte personnel',
    cloud: 'Lien Cloud',
    insurance: 'Assurance',
    estate: 'Bien immobilier',
    bank: 'Établissement bancaire',
    // securities: 'Valeur mobilière',
    art: 'Œuvres d\'art & collections',
    item: 'Objets de valeur',
    other_investment: 'Titres & placements',
    intellectual: 'Propriété intellectuelle',
    subscription: 'Abonnements',
    finance: 'Finances',
    housing: 'Maison & propriété',
    shop: 'Fonds de commerce',
    contract: 'Contrats',
    company: 'Sociétés',
    text: 'Texte libre',
    album: 'Album',
    item_memory: 'Objet mémoriel',
  };
  return list[cat] || 'Autres';
}

export function getMainCategoryName(mainCat) {
  const list = {
    numeric: 'Patrimoine numérique',
    classic: 'Patrimoine classique',
    professional: 'Patrimoine professionnel',
    memories: 'Souvenirs',
    planner: 'Administratif',
  };
  return list[mainCat] || 'Autre';
}

export function getSubCategoryName(data) {
  const { category: cat, subcategory: subCat, bank_location } = data;
  const test = listPlatforms.find(e => e.category === cat && e.subcategory === subCat);
  if (test) {
    return test.subcategory_label;
  }
  const listSubCat = {
    life_insurance: 'Assurance vie',
    funeral_insurance: 'Assurance obsèques',
    provident_insurance: 'Assurance prévoyance',
    copyright: 'Droits d\'auteur',
    industrial: 'Propriété industrielle',
    employee_savings_plan: 'Plan d\'épargne salariale',
    madelin: 'Contrat Madelin',
    collective_pension: 'Prévoyance collective',
    other_contract: 'Contrats divers',
    house_insurance: 'Assurance habitation',
    car_insurance: 'Assurance auto',
    insurance_goods: 'Assurance de biens',
    insurance_person: 'Assurance de personnes',
    mutuelle: 'Mutuelle',
    loan: 'Crédits',
    boss: 'Mon employeur',
    retired: 'Caisse de retraite',
    owner: 'Mon propriétaire',
    tenant: 'Mes locataires',
    trustee: 'Syndic',
    car: 'Véhicule',
    maid: 'Employés à domicile',
    pet: 'Animaux',
    mobile: 'Téléphonie',
    energy: 'Énergie & Eau',
    water: 'Eau',
    internet_box: 'Box internet',
    tv: 'Divertissement',
    magazine: 'Presse',
    software: 'Logiciels & Applications',
  };
  if (['insurance', 'intellectual', 'contract', 'finance', 'housing', 'subscription'].includes(cat)) {
    return listSubCat[subCat];
    // if (subCat === 'life_insurance') return 'Assurance vie';
    // if (subCat === 'funeral_insurance') return 'Assurance obsèques';
    // if (subCat === 'provident_insurance') return 'Assurance prévoyance';
  }
  if (cat === 'art') return 'Œuvre d\'art ou collection';
  if (cat === 'item') return 'Objet de valeur';
  if (cat === 'shop') return 'Fonds de commerce';
  if (cat === 'company') return 'Sociétés';
  if (cat === 'bank') {
    if (bank_location === 'france') return 'Banque française';
    if (bank_location === 'other') return 'Banque étrangère';
  }
  const otherTry = getCategoryName(cat);
  return otherTry || '';
}

export function getSubCategoryParentByTitleName(title) {
  const test = listPlatforms.find(e => e.title === title);
  if (test) {
    return test.subcategory_parent;
  }
  return '';
}

export function getPlatformName(subCat, platform) {
  let val = '';
  if (subCat === 'online_account' || subCat === 'social_network') {
    const list = getPlatformList(subCat);
    list.map((item) => {
      if (item.value === platform) val = item.label;
      return 'ok';
    });
  }
  return val;
}

export function getContactsAssets(assets, contacts) {
  const endArr = [];
  contacts.forEach((item) => { endArr.push({ name: item.name, id: item._id, list: [] }); });
  assets.forEach((item) => {
    if (item.contacts && item.contacts.length > 0) {
      item.contacts.forEach((subItem) => {
        const name = getContactName(contacts, subItem);
        const index = endArr.findIndex(x => x.name === name);
        if (endArr[index] && endArr[index].list) endArr[index].list.push(item);
      });
    }
  });
  endArr.sort((a, b) => b.list.length - a.list.length);
  console.log('end array is: ', endArr);
  return endArr;
}

export function getContactsByCategory(contacts, category) {
  let list;
  if (category !== 'other') {
    list = contacts.filter(item => item.categories.includes(category));
  } else {
    list = contacts.filter(item => !item.categories || item.categories.length === 0);
  }
  return list;
}

/* eslint-disable no-restricted-properties */
export function formatBytes(bytes, decimals = 2) {
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))}  ${sizes[i]}`;
}
